import { render, staticRenderFns } from "./Digitization.vue?vue&type=template&id=0703a3e7&scoped=true"
import script from "./Digitization.vue?vue&type=script&lang=js"
export * from "./Digitization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0703a3e7",
  null
  
)

export default component.exports